import React from "react";
import SweetAlert from "../../components/SweetAlertWrapper";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import UserSearch from "components/UserSearch.jsx";

import mensagensStyle from "assets/jss/material-dashboard-pro-react/views/mensagensStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import connection from "../../connection";
import general from "../../general";

import Add from "@material-ui/icons/Add";
import Inbox from "@material-ui/icons/Inbox";
import Unarchive from "@material-ui/icons/Unarchive";

import moment from "moment";
import Parser from 'html-react-parser';

import {ContentState, convertFromHTML, convertToRaw, EditorState} from 'draft-js'
import draftToHtml from 'draftjs-to-html';
import {Editor} from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//FontAwesome Icons
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle, faShare, faTrash} from '@fortawesome/free-solid-svg-icons';

class Mensagens extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      recebidas: [],
      enviadas: [],
      activeTab: "recebidas",
      currentMsg: 0,
      detalhes: null
    };

    this.mensagem_id = null;

    this.loadRecebidas = this.loadRecebidas.bind(this);
    this.loadEnviadas = this.loadEnviadas.bind(this);
    this.openMensagem = this.openMensagem.bind(this);
    this.deleteMensagem = this.deleteMensagem.bind(this);
    this.novaMensagem = this.novaMensagem.bind(this);
  }

  loadRecebidas() {
    connection.get("mensagens/listar/recebidas", null, (data) => {
      this.setState({
        recebidas: data.mensagens,
        activeTab: "recebidas"
      });
      if (this.mensagem_id) {
        let found_msg = data.mensagens.find((msg) => msg.id === parseInt(this.mensagem_id, 10));
        if (found_msg) {
          this.mensagem_id = null;
          this.openMensagem(found_msg, data.mensagens.indexOf(found_msg));
          return;
        }
      }
      if (data.mensagens.length > 0)
        this.openMensagem(data.mensagens[0], 0);
    });
  }

  loadEnviadas() {
    connection.get("mensagens/listar/enviadas", null, (data) => {
      this.setState({
        enviadas: data.mensagens,
        activeTab: "enviadas"
      });
      if (data.mensagens.length > 0)
        this.openMensagem(data.mensagens[0], 0);
    });
  }

  openMensagem(mensagem, msgidx) {
    const {classes} = this.props;

    if (this.state.activeTab === "recebidas" && !mensagem.visto) {
      connection.post("mensagens/marcar-lida", {id: mensagem.id}, (data) => {
        let recebidas = this.state.recebidas;
        recebidas[msgidx].visto = true;
        this.setState({
          recebidas: recebidas
        });
      })
    }

    this.setState({
      currentMsg: msgidx,
      detalhes: (
        <React.Fragment>
          <div className={classes.wrapperDetalhe}>
            <div className={classes.detalheTop}>
              <span className={classes.detalheAssunto}>{mensagem.assunto}</span>
              <div className={classes.detalheDelete} onClick={() => {
                this.deleteMensagem(mensagem)
              }}>
                <FontAwesomeIcon icon={faTrash}/>
              </div>
              <div className={classes.detalheResponder}
                   onClick={() => {
                     this.novaMensagem(mensagem)
                   }}>
                <FontAwesomeIcon icon={faShare}/>
              </div>
            </div>
            <p className={classes.detalheBottom}>
              <span>De: {mensagem.remetente.id ? [mensagem.remetente.nome, <span className={classes.detalheNin}> (NIN: {mensagem.remetente.NIN})</span>] : "Remetente desconhecido"}</span>
              <br/>
              <span>Para: {mensagem.destinatario.id ? [mensagem.destinatario.nome, <span className={classes.detalheNin}> (NIN: {mensagem.destinatario.NIN})</span>] : "Destinatário desconhecido"}</span>
              <span className={classes.detalheData}>{moment(mensagem.data).format("DD/MM/YYYY [às] H:mm")}</span>
            </p>
          </div>
          <div className={classes.detalheCorpo}>
            <div className={classes.detalheCorpoInner}>
              {Parser(mensagem.corpo.split("\n").join("<br/>"))}
            </div>
          </div>
        </React.Fragment>
      )
    })
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  deleteMensagem(mensagem) {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Mensagem"
          onConfirm={() => {
            connection.post("mensagens/apagar", {id: mensagem.id}, (data) => {
              if (data.success) {
                this.hideModal();
                if (this.state.activeTab === "recebidas") {
                  this.loadRecebidas();
                } else if (this.state.activeTab === "enviadas") {
                  this.loadEnviadas();
                }
                this.setState({detalhes: null});
                general.success("Mensagem apagada com sucesso.", "Sucesso!");
              } else {
                general.error("Por favor tente novamente mais tarde.", "Erro!")
              }
            })
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Ao apagar esta mensagem não poderá voltar a relê-la.
        </SweetAlert>
      )
    });
  }

  novaMensagem(original) {
    const {classes} = this.props;
    let mensagem = {
      destinatario: original ? (this.state.activeTab === "recebidas" ? (original.remetente || original.destinatario) : original.destinatario).id : null,
      assunto: original && original.assunto ? ("Re: " + original.assunto) : "",
      corpo: original && original.corpo ? ("\n--------\n" + original.corpo) : ""
    };

    let setEditorRef = (ref) => {
      if (original) {
        setTimeout(() => {
          ref && ref.focus(0);
        }, 5);
      }
    };

    let editorState;
    if (original && original.corpo) {
      editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(mensagem.corpo.split("\n").join("<br/>"))
        )
      );
    } else {
      editorState = EditorState.createEmpty();
    }

    let editorSetMessage = (es) => {
      mensagem.corpo = draftToHtml(convertToRaw(es.getCurrentContent()));
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 820}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Nova Mensagem</span>
        </div>)}
        onConfirm={() => {
          connection.post("mensagens/nova", mensagem, (data) => {
            if (data.success) {
              this.hideModal();
              this.loadEnviadas();
              general.success("Mensagem enviada com sucesso.", "Sucesso!");
            } else {
              general.error("Por favor tente novamente mais tarde.", "Erro!")
            }
          })
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Enviar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN ou Email do Destinatário"
            id="novaMensagem-destinatario"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "destinatario"
            }}
            defaultUser={original ? (this.state.activeTab === "recebidas" ? (original.remetente || original.destinatario) : original.destinatario) : null}
            onFoundUser={(user) => {
              mensagem.destinatario = user.id
            }}
          />
          <CustomInput
            labelText="Assunto"
            id="novaMensagem-assunto"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "assunto",
              defaultValue: mensagem.assunto,
              onChange: (e) => {
                mensagem.assunto = e.target.value
              }
            }}
          />
          <div style={{
            background: "#fbfbfb",
            padding: 5,
            borderRadius: 5,
            marginTop: 5
          }}>
            <Editor
              defaultEditorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName={"editor-class " + classes.mensagemEditor}
              toolbarClassName={"toolbar-class " + classes.mensagemToolbar}
              onEditorStateChange={(es) => {
                editorState = es;
                editorSetMessage(es);
              }}
              toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
              }}
              editorRef={setEditorRef}
            />
          </div>
        </form>
      </SweetAlert>)
    });
  }

  componentDidMount() {
    if (window.App.hist.location.state && window.App.hist.location.state.destinatario)
      this.novaMensagem({destinatario: window.App.hist.location.state.destinatario});
    let mensagem_id = this.props.location.pathname.split("/mensagens/")[1];
    if (mensagem_id) {
      this.mensagem_id = mensagem_id;
    }
    this.loadRecebidas();
  }

  render() {
    const {classes} = this.props;

    let listaMensagens = (<span className={classes.listaMensagensVazia}>Sem mensagens.</span>)
    if (this.state.activeTab === "recebidas" && this.state.recebidas.length > 0) {
      listaMensagens = [];
      this.state.recebidas.forEach((mensagem, idx) => {
        listaMensagens.push((
          <div key={mensagem.id} className={classes.wrapperMensagem + (mensagem.visto ? " visto" : "") + (this.state.currentMsg === idx ? " active" : "")}
               onClick={() => {
                 this.openMensagem(mensagem, idx)
               }}>
            <p className={classes.mensagemTop}>
              <span className={classes.mensagemAssunto}>{mensagem.assunto}</span>
              {mensagem.visto ? null : (<FontAwesomeIcon icon={faCircle}/>)}
            </p>
            <p className={classes.mensagemBottom}>
              <span>De: {mensagem.remetente.nome || 'Remetente desconhecido'}</span>
              <span className={classes.mensagemData}>{moment(mensagem.data).format("DD/MM/YYYY [às] H:mm")}</span>
            </p>
          </div>
        ));
      })
    } else if (this.state.activeTab === "enviadas" && this.state.enviadas.length > 0) {
      listaMensagens = [];
      this.state.enviadas.forEach((mensagem, idx) => {
        listaMensagens.push((
          <div key={mensagem.id} className={classes.wrapperMensagem + (this.state.currentMsg === idx ? " active" : "")}
               onClick={() => {
                 this.openMensagem(mensagem, idx)
               }}>
            <p className={classes.mensagemTop}>
              <span className={classes.mensagemAssunto}>{mensagem.assunto}</span>
            </p>
            <p className={classes.mensagemBottom}>
              <span>Para: {mensagem.destinatario.nome || ' Destinatário desconhecido'}</span>
              <span className={classes.mensagemData}>{moment(mensagem.data).format("DD/MM/YYYY [às] H:mm")}</span>
            </p>
          </div>
        ));
      })
    }

    return (<div className={classes.mensagensContainerWrapper}>
      {this.state.modal}
      <div className={classes.mensagensContainer}>
        <Card className={classes.sidebarCard}>
          <CardBody className={classes.sidebarCardBody}>
            <div className={classes.buttonNovaMensagem} onClick={() => {
              this.novaMensagem()
            }}>
              <Add/>
              <span>Nova Mensagem</span>
            </div>
            <ul className={classes.sidebarUl}>
              <li
                onClick={this.loadRecebidas}
                className={this.state.activeTab === "recebidas" ? "active" : null}>
                <Inbox/><span>Recebidas</span>
              </li>
              <li
                onClick={this.loadEnviadas}
                className={this.state.activeTab === "enviadas" ? "active" : null}>
                <Unarchive/><span>Enviadas</span>
              </li>
            </ul>
          </CardBody>
        </Card>
        <Card className={classes.mensagensListaCard}>
          <CardBody className={classes.mensagensListaCardBody}>
            {listaMensagens}
          </CardBody>
        </Card>
        <Card className={classes.detalhesCard}>
          <CardBody className={classes.detalhesCardBody}>
            {this.state.detalhes}
          </CardBody>
        </Card>
      </div>
    </div>)
  }
}

export default withStyles(mensagensStyle)(Mensagens);
